import { useState } from 'react';

export const DebtTicketsHook = ({ billingCycleInfo }) => {
  const [isCopied, setIsCopied] = useState(false);

  const handleCopyLink = async () => {
    const linkToCopy = billingCycleInfo?.payment_link?.[0];

    if (linkToCopy) {
      try {
        await navigator.clipboard.writeText(linkToCopy);
        setIsCopied(true);

        setTimeout(() => {
          setIsCopied(false);
        }, 2000);
      } catch (err) {
        console.error('Error al copiar el enlace: ', err);
      }
    }
  };

  const calculateDaysRemaining = (targetDateString) => {
    if (!targetDateString) return null;

    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const targetDate = new Date(targetDateString);
    targetDate.setHours(0, 0, 0, 0);

    const diffInMilliseconds = targetDate - today;
    const diffInDays = Math.ceil(diffInMilliseconds / (1000 * 60 * 60 * 24));

    if (diffInDays > 0) {
      return `(Corte en ${diffInDays} día${diffInDays === 1 ? '' : 's'})`;
    } else if (diffInDays === 0) {
      return '(Corte es hoy)';
    } else {
      const overdueDays = Math.abs(diffInDays);
      return `(Vencido hace ${overdueDays} día${overdueDays === 1 ? '' : 's'})`;
    }
  };
  return {
    isCopied,
    handleCopyLink,
    calculateDaysRemaining,
  };
};
